@if (mostrarProxima && proximaMissao; as p) {
  <section class="mg-missoes__proxima">
    <p class="mg-missoes__eyebrow">Sua próxima melhor ação</p>
    <h4 class="mg-missoes__proxima-titulo">{{ entrada(p.id).titulo }}</h4>
    <p class="mg-missoes__proxima-ganho">{{ entrada(p.id).ganho }}</p>
    <div class="mg-missoes__proxima-acoes">
      @if (p.estado !== 'em_breve') {
        <span class="mg-missao__xp">{{ xp(p) }}</span>
      }
      @if (podeVer(entrada(p.id).permissao)) {
        <kt-button appearance="filled" (handle)="irPara.emit(entrada(p.id).rota)">Abrir {{ entrada(p.id).tela }}</kt-button>
      } @else {
        <span class="mg-missao__sem-acesso">Peça ao administrador acesso a {{ entrada(p.id).tela }}.</span>
      }
    </div>
  </section>
}

<!--
  `mat-accordion` + `mat-expansion-panel` de verdade (Lei 1): Esc, foco, seta
  e `aria-expanded` são do Material. O corpo não é lazy de propósito — a
  lista é curta (4 por fase) e o conteúdo precisa existir para o leitor de
  tela e para o teste.
-->
<mat-accordion class="mg-missoes" displayMode="flat">
  @for (m of missoes; track m.id) {
    <mat-expansion-panel [class]="classes(m)" [attr.data-missao]="m.id">
      <mat-expansion-panel-header>
        <mat-panel-title class="mg-missao__cabecalho">
          @switch (m.estado) {
            @case ('concluida') {
              <mat-icon svgIcon="check_circle" class="mg-icone mg-icone--p mg-missao__icone" aria-hidden="true"></mat-icon>
            }
            @case ('em_andamento') {
              <mat-icon svgIcon="schedule" class="mg-icone mg-icone--p mg-missao__icone" aria-hidden="true"></mat-icon>
            }
            @case ('atencao') {
              <mat-icon svgIcon="trending_up" class="mg-icone mg-icone--p mg-missao__icone" aria-hidden="true"></mat-icon>
            }
            @case ('em_breve') {
              <mat-icon svgIcon="lock" class="mg-icone mg-icone--p mg-missao__icone" aria-hidden="true"></mat-icon>
            }
            @case ('nao_se_aplica') {
              <mat-icon svgIcon="block" class="mg-icone mg-icone--p mg-missao__icone" aria-hidden="true"></mat-icon>
            }
            @default {
              <mat-icon svgIcon="radio_button_unchecked" class="mg-icone mg-icone--p mg-missao__icone" aria-hidden="true"></mat-icon>
            }
          }
          <span class="mg-missao__identificacao">
            <span class="mg-missao__titulo">{{ entrada(m.id).titulo }}</span>
            <span class="mg-missao__meta">
              <span class="mg-missao__estado">{{ estadoResumido(m) }}</span>
              @if (idsNovos.includes(m.id)) {
                <mat-chip class="mg-chip--destaque mg-missao__nova">Nova conquista</mat-chip>
              }
            </span>
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="mg-missao__progresso">
        <span class="mg-missao__resumo">{{ resumo(m) }}</span>
        @if (m.estado !== 'em_breve') {
          <span class="mg-missao__xp">{{ xp(m) }}</span>
        }
      </div>

      <dl class="mg-missao__detalhes">
        <dt>O que comprova a missão</dt>
        <dd>{{ entrada(m.id).criterio }}</dd>
        <dt>O que sua empresa ganha</dt>
        <dd>{{ entrada(m.id).ganho }}</dd>
        <dt>Onde continuar</dt>
        <dd>{{ entrada(m.id).tela }}</dd>
      </dl>

      @if (m.estado === 'nao_se_aplica') {
        <p class="mg-missao__excecao">
          Marcada como "não se aplica": “{{ m.excecao?.justificativa }}”
          @if (m.excecao?.usuario) {
            ({{ m.excecao?.usuario }}, {{ dataDaExcecao(m.excecao?.em ?? null) }})
          }
        </p>
        <kt-button
          appearance="outlined"
          [class]="'mg-missao__reconsiderar'"
          [loading]="excecaoEmAndamento === m.id"
          (handle)="removerExcecao.emit(m.id)">Voltar a considerar</kt-button>
      }

      @if (temAcoes(m)) {
        <div class="mg-missao__acoes">
          @if (podeVer(entrada(m.id).permissao)) {
            <kt-button appearance="tonal" [class]="'mg-missao__ir'" (handle)="irPara.emit(entrada(m.id).rota)">Abrir {{ entrada(m.id).tela }}</kt-button>
            @if (podeFocar(m)) {
              <kt-button appearance="text" [class]="'mg-missao__focar'" (handle)="focar.emit(m.id)">Focar nesta missão</kt-button>
            }
          } @else {
            <span class="mg-missao__sem-acesso">Peça ao administrador acesso a {{ entrada(m.id).tela }}.</span>
          }
        </div>
      }

      @if (podeExcetuar(m)) {
        <details class="mg-missao__excetuar">
          <summary>Não se aplica à minha empresa</summary>
          <label class="mg-missao__justificativa">
            <span>Por quê? (de {{ minimo }} a {{ maximo }} caracteres; fica registrado com o seu nome)</span>
            <textarea rows="3" [attr.minlength]="minimo" [attr.maxlength]="maximo" (input)="aoDigitar(m.id, $event)"></textarea>
          </label>
          <kt-button
            appearance="outlined"
            [class]="'mg-missao__nao-se-aplica'"
            [disabled]="!justificativaValida(m.id)"
            [loading]="excecaoEmAndamento === m.id"
            (handle)="emitirNaoSeAplica(m.id)">
            Marcar como não se aplica
          </kt-button>
        </details>
      }
    </mat-expansion-panel>
  }
</mat-accordion>
